import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { configureAmplify } from '@eir/aws-authorization';
import GroupContractSwedenView from './views/GroupContractSweden/GroupContractSwedenView';
import InsuranceLetterSwedenView from './views/InsuranceLetterSweden/InsuranceLetterSwedenView';
import './styles/fonts.css';
import GlobalStyle from './styles/globalStyle';
configureAmplify(
  {
    endpointName: 'AvonovaAPI',
    endpointUrl: process.env.REACT_APP_AWS_ENDPOINT_URL,
  },
  true
);
const App = () => {
  return (
    <Router>
      <GlobalStyle />
      <Switch>
        <Route
          exact
          path='/se/p/:policyId'
          render={({ match }) => {
            window.location.href = `${process.env.REACT_APP_PARTNER_HUB_URL}p/${match.params.policyId}`;
            return null;
          }}
        />
        <Route
          exact
          path='/se/q/:quoteId'
          render={({ match }) => {
            window.location.href = `${process.env.REACT_APP_PARTNER_HUB_URL}q/${match.params.quoteId}`;
            return null;
          }}
        />
        <Route exact path='/se/q-old/:policyId' component={GroupContractSwedenView} />
        <Route exact path='/se/p-old/:policyId' component={InsuranceLetterSwedenView} />
      </Switch>
    </Router>
  );
};
export default App;
